// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"f60c3af0-168":"c07001ebb362e7edf633","f60c3af0-452":"fa603999b32bf60d1f61","f60c3af0-379":"e2c6571c860ed847ae2a","f60c3af0-83":"c5db58e6b74ea0922814"}[chunkId] + ".js";
};